import React from 'react';
import './Footer.css'

const Footer = () =>{
    return(
        <>
            <footer>
                <div className="container-fluid d-flex justify-content-center">
                    &copy; Zomato
                </div>    
            </footer>
        </>
    )
}

export default Footer;